export const resolveComposerIsRoomEncrypted = (
    selectedRoomId: string | null,
    isRoomEncrypted: (roomId: string) => boolean
): boolean => (selectedRoomId ? isRoomEncrypted(selectedRoomId) : true);
